<div *ngIf="isLoading" style="min-height: 200px;">
  <div class="overlay">
    <div class="spinner"></div>
  </div>
</div>
